#import "../fragments/setting-fragment.graphql"

mutation UpdateSetting($setting: UpdateSettingFieldInput!) {
    updateSetting(input: {setting: $setting}) {
        setting {
            ...Setting
        }
    }
}
